export const HIPS_AND_EXTREMITIES_SECTION_INITIAL_VALUES = {
  normal: false,
  notNormal: false,
  declined: false,
  normalDetails: [],
  notNormalDetails: [],
  notes: "",
};

export const HIPS_AND_EXTREMITIES_FORM_INITIAL_VALUES = {
  sections: {
    hipsHipsAndExtremities: HIPS_AND_EXTREMITIES_SECTION_INITIAL_VALUES,
    toneHipsAndExtremities: HIPS_AND_EXTREMITIES_SECTION_INITIAL_VALUES,
    rangeOfMotionHipsAndExtremities: HIPS_AND_EXTREMITIES_SECTION_INITIAL_VALUES,
    digitsHipsAndExtremities: HIPS_AND_EXTREMITIES_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type NewbornPostpartumPhysicalExamsHipsAndExtremitiesSections =
  keyof typeof HIPS_AND_EXTREMITIES_FORM_INITIAL_VALUES.sections;
